﻿import React, { forwardRef, ReactNode, useImperativeHandle, useRef, useState } from 'react';

import { ButtonProps } from 'components/GMetrixDialogConfirm/GMetrixDialogConfirm';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';

import 'components/GMetrixDialogPrompt/gmetrix-dialog-prompt.scss';

import { FormattedMessage } from 'react-intl';
import { Modal } from 'react-bootstrap';
import { useStableId } from 'hooks';

export interface ModalProps {
    buttonProps?: ButtonProps;
    size?: 'lg' | 'sm' | 'xl' | undefined;
}

const GMetrixDialogShell = forwardRef((props, forwardRef) => {

    const titleId = useStableId('gmx-dialog-title');
    const [title, setTitle] = useState<ReactNode>(false);
    const [body, setBody] = useState<ReactNode>(false);
    const [modalProps, setModalProps] = useState<ModalProps>({ buttonProps: { hideCancel: false, variant: 'primary' } });
    const [showModal, setShowModal] = useState<boolean>(false);
    const [result, setResult] = useState<any>(null);
    const resolveRef = useRef(null);
    const resolve: any = resolveRef?.current;

    const createDialog = (
        title: ReactNode,
        body: ReactNode,
        modalProps?: ModalProps,
        result?: any
    ) => new Promise(resolve => {

        (resolveRef.current as any) = resolve;

        setShowModal(true);
        setTitle(title);
        setBody(body);
        if (result) {

            setResult(result);

        }
        if (modalProps) {

            setModalProps(modalProps);

        }

    });

    const closeSuccessfulDialog = () => {

        setShowModal(false);

        resolve({ success: true });

    };

    const cancelDialog = () => {

        setShowModal(false);
        resolve({ success: false });

    };

    const closeDialog = () => {

        setShowModal(false);
        resolve(null);

    };

    useImperativeHandle(forwardRef, () => ({
        create: createDialog
    }), []);

    return (
        <Modal aria-labelledby={titleId} onHide={closeDialog} show={showModal} size={modalProps.size}>
            {

                <Modal.Header closeButton>
                    <Modal.Title id={titleId}>
                        {title ? title : 'Notice'}
                    </Modal.Title>
                </Modal.Header>

            }
            <Modal.Body style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                {
                    typeof body === 'string'
                        ? (
                            <p>
                                {body}
                            </p>
                        )
                        : body
                }
            </Modal.Body>
            <Modal.Footer>
                {!modalProps.buttonProps?.hideCancel && (
                    <GMetrixButton
                        className={`btn btn-sm`}
                        onClick={cancelDialog}
                        style={{ minWidth: 82 }}
                        type='button'
                        variant='secondary'
                    >
                        <FormattedMessage defaultMessage="Cancel" id="cancel.89a86adc" />
                    </GMetrixButton>
                )}
                <GMetrixButton
                    className={`btn btn-sm`}
                    iconClass={modalProps.buttonProps?.iconClass}
                    onClick={closeSuccessfulDialog}
                    style={{ minWidth: 82 }}
                    type='button'
                    variant={modalProps.buttonProps?.variant}
                >
                    {modalProps.buttonProps?.buttonText ?? <FormattedMessage defaultMessage="Confirm" id="confirm.297ab8f4" />}
                </GMetrixButton>

            </Modal.Footer>
        </Modal>
    );

});
GMetrixDialogShell.displayName = 'GMetrixDialogShell';
export default GMetrixDialogShell;